const config = {
  api: {
    baseURL: "https://api.tak8.com.au",
    emailEndpoint: "https://api.tak8.com.au/email/send",
  },
  contact: {
    email: "info@tak8.com.au",
  },
  booking: {
    email: "bookings@tak8.com.au",
  },
};

export default config;
